module.exports = __webpack_public_path__ + "img/wheel-small.d48cbb18.svg";